import { BASE_API } from "../../utils/constantes";
import { getToken } from "../Common/token";

export async function getListaAuditoria(queryParam) {
    try {
        const url = `${BASE_API}/auditoria/historial-logs?${queryParam}`;
        const params = {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        };
        const response = await fetch(url, params);
        if (response.status === 200) {
            return response.json().then((data) => data);
        }
        return [];
    } catch (error) {
        throw new Error("Hubo un problema, vuelva a intentar");
    }
}